import { gql } from "@apollo/client";

export const GET_BP_CLIENTE = gql`
query clienteByCodigo($codigo: String!) {
    clienteByCodigo(codigo: $codigo) {
        valorEsperado{
            bP
        }
        success
        error
    }
}`;